import { gql } from '@apollo/client';

import TRANSACTION_TYPES_FRAGMENT from '../fragments/services/transactionTypes';
import TRANSACTIONS_FRAGMENT from '../fragments/transactions';

export const CREATE_TRANSACTION = gql`
  ${TRANSACTIONS_FRAGMENT}
  ${TRANSACTION_TYPES_FRAGMENT}
  mutation createTransactionEntity($doc: TransactionInput!) {
    createTransactionEntity(doc: $doc) {
      ...TransactionsFragment
      transactionType {
        ...TransactionTypesFragment
      }
    }
  }
`;

export const UPDATE_TRANSACTION = gql`
  ${TRANSACTIONS_FRAGMENT}
  mutation updateTransactionEntity($updatedDoc: TransactionInput!, $filter: TransactionInput!) {
    updateTransactionEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...TransactionsFragment
      transactionType {
        ...TransactionTypesFragment
      }
    }
  }
`;

export const ASSIGN_TRANSACTION = gql`
  ${TRANSACTIONS_FRAGMENT}
  mutation assignTransaction($transaction: String!, $assigner: String!) {
    assignTransaction(transaction: $transaction, assigner: $assigner) {
      ...TransactionsFragment
      transactionType {
        ...TransactionTypesFragment
      }
    }
  }
`;

export const REMOVE_ASSIGN_TRANSACTION = gql`
  ${TRANSACTIONS_FRAGMENT}
  mutation removeAssignTransaction($transaction: String!, $assigner: String!) {
    removeAssignTransaction(transaction: $transaction, assigner: $assigner) {
      ...TransactionsFragment
      transactionType {
        ...TransactionTypesFragment
      }
    }
  }
`;

// export const CREATE_FILES = gql`
//   mutation createManyFileEntity($doc: [FileInput!]!) {
//     createManyFileEntity(doc: $doc) {
//       name
//     }
//   }
// `;
